import { URLSearchParamsCompat } from './URLSearchParamsCompat';
import { config } from 'env_def';
export function getHelperCenterUrl(options) {
    const { isEnLang, isEDM, productVersionId } = options;
    const isFree = productVersionId === 'free';
    const params = new URLSearchParamsCompat({
        k: 'hc',
        isENLang: String(isEnLang),
        isEDM: String(isEDM),
        isFree: String(isFree),
    });
    return `${config('helperCenterUrl')}?${params.toString()}`;
}
